__webpack_require__.p = "/assets/turbo/c7d1653f/quellede/_next/";